import { getTimeZone } from '@/utils/dateHelpers';
import axios from '../utils/axiosClient';
import endpoints from './endpoints';

const {
  getTransactions,
  getCategories,
  getTotalAmounts,
  getFinancialOverviewStatistic,
  getTxPendingReport,
  getReportTransactions,
  getExpenseBreakdownStatistic,
  getTxReport,
  getTxToken,
  getSubUserTransaction,
  getPendingTransactions,
  getPendingTransDetails,
  getPendingTransComplianceDoc,
} = endpoints;

const loadCategories = async () => {
  try {
    const response = await axios.get(getCategories);
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const loadTransactions = async (params: any) => {
  try {
    const response = await axios.get(getTransactions, { params });
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const reportTransactions = async (params: any) => {
  try {
    const response = await axios.get(getReportTransactions, { params });
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const loadPendingTransactions = async (params: any) => {
  try {
    const response = await axios.get(getPendingTransactions, { params });
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const loadDetails = async (id: string) => {
  try {
    const response = await axios.get(getPendingTransDetails(id));
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const loadSubUserTransaction = async (params: any) => {
  try {
    const response = await axios.get(getSubUserTransaction, { params });
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const loadTotalAmounts = async (params: any) => {
  try {
    const response = await axios.get(getTotalAmounts, { params });
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const downloadExistReport = async (transactionId: any) => {
  try {
    const response = await axios.get(`${getTxReport}/${transactionId}`, { responseType: 'blob' });
    const fileBlob = new Blob([response.data], { type: response.headers['content-type'] });
    const fileUrl = URL.createObjectURL(fileBlob);

    return window.open(fileUrl, '_blank');
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const downloadPendingReport = async (transactionId: string) => {
  try {
    const response = await axios.get(getTxPendingReport(transactionId), { responseType: 'blob' });
    const fileBlob = new Blob([response.data], { type: response.headers['content-type'] });
    const fileUrl = URL.createObjectURL(fileBlob);

    return window.open(fileUrl, '_blank');
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const downloadListReports = async (params: any) => {
  try {
    const filters = { ...JSON.parse(params), zoneOffset: getTimeZone(JSON.parse(params).startDate), format: 'PDF' };
    const queryParams = new URLSearchParams(filters).toString();

    const response = await axios.get(`${getTxReport}?${queryParams}`, { responseType: 'blob' });
    const fileBlob = new Blob([response.data], { type: response.headers['content-type'] });
    const fileUrl = URL.createObjectURL(fileBlob);

    return window.open(fileUrl, '_blank');
  } catch (error: any) {
    return Promise.reject(error.response.data.text());
  }
};

const loadFinancialOverviewStatistic = async (params: any) => {
  try {
    const response = await axios.get(getFinancialOverviewStatistic, { params });
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const loadExpenseBreakdownStatistic = async (params: any) => {
  try {
    const response = await axios.get(getExpenseBreakdownStatistic, { params });

    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const getTxReportToken = async (id: string) => {
  try {
    const response = await axios.post(getTxToken.replace(':ID', id));

    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const fetchPendingTransComplianceDoc = async (id: string, params: any) => {
  try {
    const response = await axios.get(getPendingTransComplianceDoc(id), { params, responseType: 'blob' });
    const fileBlob = new Blob([response.data], { type: response.headers['content-type'] });
    return URL.createObjectURL(fileBlob);
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const transactionsServices = {
  loadTransactions,
  loadCategories,
  loadTotalAmounts,
  downloadExistReport,
  downloadListReports,
  loadFinancialOverviewStatistic,
  loadExpenseBreakdownStatistic,
  getTxReportToken,
  loadSubUserTransaction,
  loadPendingTransactions,
  downloadPendingReport,
  loadDetails,
  reportTransactions,
  fetchPendingTransComplianceDoc,
};

export default transactionsServices;
